import type { ComponentContentSchema, SlotGroupDefinition } from '@vibesites/runtime';
import { EditableSlotGroup, EditableToken, RichTextContent } from '@vibesites/runtime/react';
import { InnerPageHeroSubtitle } from './shared/InnerPageHeroSubtitle';
import {
  INNER_PAGE_HERO_TITLE_CLASS,
  InnerPageHeroSection,
} from './shared/InnerPageHeroSection';

const bgImageDef: SlotGroupDefinition = {
  label: 'Background Image',
  fields: {
    image: {
      label: 'Image',
      type: 'image',
      defaultField: 'property_featured_image',
    },
    alt: {
      label: 'Alt Text',
      type: 'text',
      defaultValue: 'Preferred Employer Program banner',
    },
  },
};

export function PreferredEmployerHero() {
  return (
    <InnerPageHeroSection
      bgGroupPath="preferredemployerhero.bg_image"
      bgImageDef={bgImageDef}
      altFallback="Preferred Employer Program banner"
    >
      <InnerPageHeroSubtitle path="preferredemployerhero.subtitle" />
      <RichTextContent
        path="preferredemployerhero.title"
        as="h1"
        className={INNER_PAGE_HERO_TITLE_CLASS}
      />
      <EditableToken
        path="preferredemployerhero.subtitle"
        type="richtext"
        as="span"
        className="hidden"
        style={{ display: 'none' }}
      >
        {''}
      </EditableToken>
      <EditableSlotGroup
        groupPath="preferredemployerhero.bg_image"
        definition={bgImageDef}
        className="hidden"
        style={{ display: 'none' }}
      >
        <span />
      </EditableSlotGroup>
    </InnerPageHeroSection>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'PreferredEmployerHero',
  displayName: 'Preferred Employer Program Hero',
  tokens: {
    'preferredemployerhero.title': {
      label: 'Title',
      type: 'richtext',
      defaultValue: '<p>Preferred Employer Program</p>',
    },
    'preferredemployerhero.subtitle': {
      label: 'Subtitle',
      type: 'richtext',
      defaultValue:
        '<p>Exclusive Savings for Local Professionals at <span data-type="field-token" data-field="property_name"></span></p>',
    },
  },
  slotGroups: {
    'preferredemployerhero.bg_image': bgImageDef,
  },
};

(PreferredEmployerHero as unknown as { contentSchema: ComponentContentSchema }).contentSchema =
  contentSchema;

export default PreferredEmployerHero;
